export const ERROR_DESCRIPTION = {
    503: {
        title: 'App.applicationUnavailableTitle',
        subtitle: 'App.applicationUnavailableSubtitle'
    }
};
